import React, {useEffect, useState} from 'react';
import cl from "./FormLinkedItemSimpleSelect.module.css";
import {FormHelperText, MenuItem, TextField} from "@mui/material";
import FormControlCaption from "./FormControlCaption";
import "./helperText.css";

const nullNamesByGender = {m: "(не задан)", f: "(не задана)", n: "(не задано)", p: "(не заданы)"};

// label - заголовок элемента
// options - список итемов {id, name} из которых производить выбор. id должны быть уникальными и не нулевыми, name будет отображаться
// initSelectedId - id исходно выбранного итема (должен быть из списка). допустимо значение null (ничего не выбрано)
// widthLimit - максимально допустимая ширина поля в пикс.
// controlRef - ref, предназначенный для взаимодействия с компонентом (чтение текущих данных, установки ошибки и т.п.)
// onSelect - колбэк, вызываемый каждый раз, при выборе нового значения. сигнатура: function(selectedId)
const FormLinkedItemSimpleSelect = ({
                                              label,
                                              options,
                                              initSelectedId, // undefined = пока ничего не выбрано
                                              widthLimit,
                                              controlRef,
                                              onSelect,
                                              readOnly,
                                              size = "medium", // "small"|"medium"
                                              tipText,
                                              infoText,
                                          }) => {

    const [selectedId, setSelectedId] = useState(initSelectedId === undefined ? "" : initSelectedId);
    const [errorMessage, setErrorMessage] = useState("")

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getSelectedId: getSelectedId,
                validateIsSelected: validateIsSelected,
                setErrorMessage: setErrorMessage,
            };
        }
    })

    function getSelectedId() {
        return selectedId === "" ? undefined : selectedId;
    }

    function validateIsSelected(errorMessage) {
        if (getSelectedId() !== undefined)
            return true;
        setErrorMessage(errorMessage);
        return false;
    }

    const correctedWidthLimit = widthLimit === undefined ? 10000 : widthLimit;

    // работать будем с "модифицированнными" опциями, которые могут быть шире исходных
    const modOptions = [...options];

    if ((initSelectedId !== undefined) && !modOptions.find(x => x.id === initSelectedId))
        modOptions.unshift({id: initSelectedId, name: `(id=${initSelectedId})`});

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={tipText}
            />
            <TextField
                size={size}
                select={!readOnly}
                sx={{width: `min(${correctedWidthLimit}px, 100%)`}}
                value={readOnly ? modOptions.find(x => x.id === selectedId)?.name ?? selectedId : selectedId}
                onChange={e => {
                    //const selId = parseInt(e.target.value);
                    const selId = e.target.value;
                    //console.log("selId>>", selId);
                    setSelectedId(selId);
                    if (errorMessage)
                        setErrorMessage("");
                    if (onSelect)
                        onSelect(selId === "" ? undefined : selId);
                }}
                error={errorMessage !== ""}
                helperText={errorMessage}
                slotProps={{
                    input: {
                        readOnly: readOnly,
                        sx: {
                            backgroundColor: readOnly ? "#ffff0018" : "white",
                            borderRadius: "4px",
                            /*pointerEvents: readOnly ? "none" : "auto",*/
                        }
                    },
                    formHelperText: {
                        sx: {width: "max-content"}
                    },
                    select: {
                        displayEmpty: true,
                        renderValue: selectedId !== "" ? undefined : () => <span
                            style={{opacity: "0.42"}}>Выбрать...</span>
                    },
                }}
            >
                {modOptions.map(option => <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>)}
            </TextField>
            {infoText && <FormHelperText sx={{marginLeft:"14px"}} className="helperText">
                {infoText}
            </FormHelperText>}
        </div>
    );
};

export default FormLinkedItemSimpleSelect;